import ReceivedInvoiceForm from "../components/received-invoice/ReceivedInvoiceForm";

const ReceivedInvoiceReadPage = () => {
  return <ReceivedInvoiceForm readonly={true} />;
};

export default ReceivedInvoiceReadPage;
